<template>
    <div class="main">
        <div class="body-content">
            <h3>Missing SB Report List</h3>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" />
                </div>
                <div class="form-item">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
            </div>
            <div class="form-item">
                <button type="button" class="excel-button" @click="ova_report" :disabled="isSubmitting">Generate
                    Report</button>
            </div>
            <!-- Table for transdata -->
            <div v-if="transdata && transdata.length > 0" class="table-container">
                <table class="trans-table">
                    <thead>
                        <tr>
                            <th><input type="checkbox" v-model="selectAll" @change="toggleSelectAll"></th>
                            <th>Container No</th>
                            <th>ISO Code</th>
                            <th>Vessel Name</th>
                            <th>Voyage Name</th>
                            <th>SB No</th>
                            <th>SB Date</th>
                            <th>Booking</th>
                            <th>
                                <button class="sendmail-btn" @click="sendmailSelected"
                                    :disabled="!selectedRows.length || isSubmitting">Send Mail</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in transdata" :key="row?.contnumber">
                            <td><input type="checkbox" v-model="selectedRows" :value="row" /></td>
                            <td>{{ row?.contnumber }}</td>
                            <td>{{ row?.ISOCode }}</td>
                            <td>{{ row?.Vesselname }}</td>
                            <td>{{ row?.voyagename }}</td>
                            <td>{{ row?.SBno }}</td>
                            <td>{{ row?.SBdate }}</td>
                            <td>{{ row?.booking }}</td>
                            <td>
                                <button class="sendmail-btn" @click="sendmail(row)" :disabled="isSubmitting">Send
                                    Mail</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="form-item">

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            ports: JSON.parse(localStorage.getItem('ports')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            transdata: [],
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                VoyId: 0,
                locID: 0,
                fromdate: '',
                todate: '',
            },
            htmlContent: null,
            selectedRows: [],
            selectAll: false,
            isSubmitting: false,
        }
    },
    watch: {
        selectedRows(newVal) {
            this.selectAll = newVal.length === this.transdata.length && this.transdata.length > 0;
        },
        transdata() {
            this.selectedRows = [];
            this.selectAll = false;
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async ova_report() {
            this.transdata = []
            // Validate mandatory fields
            if (!this.newContainer.partyName) {
                useToast().error('Party is required.');
                return;
            }
            if (!this.newContainer.vesselID) {
                useToast().error('Vessel is required.');
                return;
            }
            if (!this.newContainer.VoyId) {
                useToast().error('Voyage is required.');
                return;
            }
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName)
                
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    },
                };
                var fromDt = ''
                var toDt = ''
                if (this.newContainer.fromdate != '') {
                    fromDt = cs.ConvertToISODate(this.newContainer.fromdate)
                }
                if (this.newContainer.todate != '') {
                    toDt = cs.ConvertToISODate(this.newContainer.todate)
                }
                const response = await axios.get('/generate_missing_sb_list?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&vessel=' + this.newContainer.vesselID + '&voyage=' + this.newContainer.VoyId + '&location=' + this.newContainer.locID + '&fromdate=' + fromDt + '&todate=' + toDt, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transdata = response.data[2];

                }
            } catch (error) {
                useToast().error('Failed to send mail.');
            } finally {
                this.isSubmitting = false;
            }
        },
        async sendmail(row) {
            // Send the complete row data
            this.isSubmitting = true;
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const data = [row];
                const response = await axios.post('/send_missing_sb_mail', { data }, config);
                console.log(response)
                useToast().success('Mail sent successfully!');
            } catch (error) {
                useToast().error('Failed to send mail.');
            } finally {
                this.isSubmitting = false;
            }
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedRows = [...this.transdata];
            } else {
                this.selectedRows = [];
            }
        },
        async sendmailSelected() {
            if (!this.selectedRows.length) return;
            this.isSubmitting = true;
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                // Send all selected complete row data
                const data = [...this.selectedRows];
                const response = await axios.post('/send_missing_sb_mail', { data }, config);
                console.log(response)
                useToast().success('Bulk mail sent successfully!');
            } catch (error) {
                useToast().error('Failed to send bulk mail.');
            } finally {
                this.isSubmitting = false;
            }
        },
    }
}
</script>

<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.table-container {
    margin-top: 30px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    overflow-x: auto;
}

.trans-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.trans-table th,
.trans-table td {
    padding: 10px;
    border-bottom: 1px solid #eee;
    text-align: left;
}

.trans-table th {
    background-color: #f8f9fa;
    font-weight: 600;
}

.trans-table tr:hover {
    background-color: #f1f1f1;
}

.sendmail-btn {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #007bff;
    cursor: pointer;
}
.excel-button:disabled,
.sendmail-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>